<template>
  <g>
    <path
      d="M 12,1.5c2.485,0,4.5,2.015,4.5,4.5s-2.015,4.5-4.5,4.5S7.5,8.485,7.5,6S9.515,1.5,12,1.5z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M 11.625,4.5 C11.832,4.5,12,4.668,12,4.875 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M 11.25,4.875c0-0.207,0.168-0.375,0.375-0.375 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M 11.625,5.25c-0.207,0-0.375-0.168-0.375-0.375 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M 12,4.875c0,0.207-0.168,0.375-0.375,0.375 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M 12,10.5v8.25 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M 15,15.155c4.338,0.461,7.5,1.9,7.5,3.6c0,2.071-4.7,3.75-10.5,3.75 S1.5,20.821,1.5,18.75c0-1.7,3.149-3.127,7.471-3.592"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconTarget",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>